module.exports = __webpack_public_path__ + "img/caishen_1920.7566f867.png";